@if (!pending) {
<button [disabled]="disabled" (click)="PerformAction()" class="button {{btnClass}}" [type]="submit ? 'submit' : 'button'">
	<ng-content></ng-content>
</button>
}
@if (pending) {
<button class="button {{btnClass}}" disabled>{{processing}}</button>
}
@if (problem) {
<div class="problem message-bad">{{problem}}</div>
}
@if (success && complete) {
<div class="success message-good">{{complete}}</div>
}